import { SignRejectProps } from '../views/sign-reject/sign-reject.js'
import { SignSuccessProps } from '../views/sign-success/sign-success.js'

export const getSignSuccessProps = (): SignSuccessProps => {
    return {
        title: 'Signed!!!',
    }
}

export const getSignRejectProps = (): SignRejectProps => {
    return {
        title: 'Rejected!!!',
    }
}
